/** Character pool for HUD label scramble effect (waitlist + accordion idle). */
export const HUD_SCRAMBLE_CHARS = '!@#$%^&*+-=<>?/01';

/**
 * Animates `el.textContent` from random chars to `text` over `durationMs`.
 * Spaces are preserved without scrambling.
 */
export function runHudScramble(
  el: HTMLElement,
  text: string,
  durationMs: number,
): void {
  const length = text.length;
  let startTime: number | null = null;

  const animate = (timestamp: number) => {
    if (!startTime) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / durationMs, 1);
    const resolved = Math.floor(progress * length);

    let display = '';
    for (let i = 0; i < length; i++) {
      if (i < resolved) {
        display += text[i];
      } else if (text[i] === ' ') {
        display += ' ';
      } else {
        display +=
          HUD_SCRAMBLE_CHARS[
            Math.floor(Math.random() * HUD_SCRAMBLE_CHARS.length)
          ];
      }
    }

    el.textContent = display;
    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      el.textContent = text;
    }
  };

  requestAnimationFrame(animate);
}
